// src/pages/TermsOfUse.js
import React from 'react';
import '../styles/termsOfUse.css'; // Import CSS for styling

const TermsOfUse = () => {
  return (
    <div className="terms-of-use-container">
      {/* Paste the entire HTML content of the Terms of Use here */}
      <h1>Terms of Use</h1>

      <p>Effective Date:28 April 2025</p>

      <p>Welcome to EdGeneOnline! These Terms of Use ("Terms") govern your access to and use of the EdGeneOnline website www.edgeneonline.com and our services. By accessing or using our website and services, you agree to be bound by these Terms.</p>

      <h2>Acceptance of Terms</h2>

      <p>By accessing or using our website and services, you confirm that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use our website or services.</p>

      <h2>Use of Our Services</h2>

      <p>You agree to use our website and services only for lawful purposes and in accordance with these Terms. You agree not to:</p>

      <ul>
          <li>Use our website or services in any way that violates any applicable laws or regulations.</li>
          <li>Attempt to gain unauthorized access to our website, services, or user accounts.</li>
          <li>Interfere with or disrupt the operation of our website or services.</li>
          <li>Use our website or services to transmit any harmful or malicious code.</li>
          <li>Use our website or services to engage in any fraudulent or illegal activity.</li>
          <li>Violate the intellectual property rights of EdGene or others.</li>
      </ul>

      <h2>User Accounts</h2>

      <p>To access certain features of our website, you may need to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>

      <h2>Payment and Subscriptions</h2>

      <p>We offer various paid subscription plans. By subscribing to a paid plan, you agree to pay the applicable fees. Payments are processed securely through Paystack. You can find details about our plans and pricing on our website.</p>

      <h2>Voucher Codes</h2>

      <p>We may offer voucher codes that provide discounts on our services. Voucher codes are subject to the following terms:</p>

      <ul>
          <li>Voucher codes are valid for a limited time, as specified at the time of issuance.</li>
          <li>Voucher codes can only be redeemed once per user.</li>
          <li>Voucher codes are non-transferable and cannot be exchanged for cash.</li>
          <li>We reserve the right to modify or cancel voucher codes at any time.</li>
          <li>Vouchers can only be used by the email address that it was sent to.</li>
          <li>Vouchers expire one month after they are issued.</li>
      </ul>

      <h2>Intellectual Property</h2>

      <p>All content on our website, including text, graphics, logos, and software, is the property of EdGeneOnline or its licensors and is protected by intellectual property laws.</p>

      <h2>Disclaimer of Warranties</h2>

      <p>Our website and services are provided on an "as is" and "as available" basis. We make no warranties, express or implied, regarding the operation of our website or services.</p>

      <h2>Limitation of Liability</h2>

      <p>To the fullest extent permitted by law, EdGeneOnline shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of our website or services.</p>

      <h2>Termination</h2>

      <p>We may terminate or suspend your access to our website and services at any time, without notice, for any reason, including if you violate these Terms.</p>

      <h2>Changes to These Terms</h2>

      <p>We may update these Terms from time to time. We will notify you of any changes by posting the new Terms on this page.</p>

      <h2>Governing Law</h2>

      <p>These Terms shall be governed by and construed in accordance with the laws of the Republic of South Africa.</p>

      <h2>Contact Us</h2>

      <p>If you have any questions about these Terms, please contact us at: <a href="mailto:info@edgeneonline.com">info@edgeneonline.com</a></p>
    </div>
  );
};

export default TermsOfUse;
